import { Post } from '@libs/models';
import { PostStepperDto, PostStepperSaveDto } from '@libs/dto';

import { api } from '../common.api';

export const employerPostApi = api.injectEndpoints({
  endpoints: (build) => ({
    employerPostCreate: build.mutation<Post, PostStepperDto>({
      query: (body) => ({
        url: '/post/employer',
        method: 'POST',
        body,
      }),
    }),
    employerPostSave: build.mutation<Post, PostStepperSaveDto>({
      query: (body) => ({
        url: '/post/employer/save',
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const { useEmployerPostCreateMutation, useEmployerPostSaveMutation } = employerPostApi;
